<template>
  <div class="disponibilidad-container" v-if="permiso('BA0052EE')">
  	
	    <div class="disponibilidad-header">
	      <h2 class="disponibilidad-titulo">
	        <b-icon icon="calendar3" class="mr-2"></b-icon>
	        Ocupación Actual
	      </h2>
	      <b-button size="sm" variant="primary" @click="actualizar">
	        <b-icon icon="arrow-clockwise" class="mr-1"></b-icon>
	        Actualizar
	      </b-button>
	    </div>

	    <!-- Leyenda del Mapa de Calor -->
	    <div class="leyenda-container">
	      <div class="leyenda-item">
	        <div class="leyenda-color" style="background-color: #e5e7eb;"></div>
	        <span>Deshabilitada</span>
	      </div>
	      <div class="leyenda-item">
	        <div class="leyenda-color" style="background-color: #9ca3af;"></div>
	        <span>Baja ({{ `<= 50%` }})</span>
	      </div>
	      <div class="leyenda-item">
	        <div class="leyenda-color" style="background-color: #fbbf24;"></div>
	        <span>Media (51% - 70%)</span>
	      </div>
	      <div class="leyenda-item">
	        <div class="leyenda-color" style="background-color: #10b981;"></div>
	        <span>Óptima (71% - 90%)</span>
	      </div>
	      <div class="leyenda-item">
	        <div class="leyenda-color" style="background-color: #ef4444;"></div>
	        <span>Alta (91% - 100%)</span>
	      </div>
	    </div>

      <div class="filtro-fecha-container" v-if="fechasAgendaOptions.length">
        <label class="filtro-fecha-label">Fecha</label>
        <b-form-select
          v-model="fechaSeleccionada"
          :options="fechasAgendaOptions"
          class="filtro-fecha-select"
          @change="reiniciarColapsoDia"
        ></b-form-select>
      </div>

      <div v-if="agendaFiltrada.length" class="agenda-wrapper">

      	<div v-for="(dia, index) in agendaFiltrada" :key="dia.fecha" class="dia-section">
	    		<div class="dia-header" @click="toggleDia(index)" style="cursor: pointer;">
	    		  <div class="dia-header-content">
	    		    <div class="dia-header-left">
	    		      <b-icon :icon="diasAbiertos[index] ? 'chevron-down' : 'chevron-right'" class="mr-2 chevron-icon"></b-icon>
	    		      <h3 class="dia-titulo">{{dia.texto}}</h3>
	    		    </div>
        	    <div class="dia-resumen" v-if="totalDia()">
        	      <div class="resumen-metrica">
        	        <b-icon icon="person-x-fill" class="resumen-icon"></b-icon>
        	        <span class="resumen-contenido">
        	          <span class="resumen-etiqueta">Inasistencias</span>
        	          <strong>{{ totalDia().totalInasistencias }}</strong>
        	        </span>
        	      </div>
        	      <div class="resumen-metrica">
        	        <b-icon icon="x-circle-fill" class="resumen-icon"></b-icon>
        	        <span class="resumen-contenido">
        	          <span class="resumen-etiqueta">Cancelaciones</span>
        	          <strong>{{ totalDia().totalCancelaciones }}</strong>
        	        </span>
        	      </div>
        	      <div class="resumen-metrica resumen-metrica-ocupacion">
        	        <b-icon icon="people-fill" class="resumen-icon"></b-icon>
        	        <span class="resumen-contenido">
        	          <span class="resumen-etiqueta">Ocupación total</span>
        	          <strong>{{ totalDia().ocupacionTotal }}</strong>
        	        </span>
        	      </div>
        	    </div>
	    		  </div>
	    		</div>

        	<b-collapse :visible="diasAbiertos[index]" :id="'collapse-dia-' + index">
        	  <div class="tabla-scroll">
        	    <div class="tabla-disponibilidad">
	    		    <b-row class="tabla-header" v-if="tipos">
	    		    	<b-col class="celda-head text-center" cols="1">Hora</b-col>
	    		    	<b-col class="celda-head text-center" v-for="(tipo, t_index) in tipos" :key="t_index">
              		<span class="tipo-nombre tipo-nombre-completo">{{tipo.nombre}}</span>
              		<span class="tipo-nombre tipo-nombre-corto">{{tipo.nombre_corto}}</span>
	    		    	</b-col>
                <b-col class="celda-head celda-head-total text-center">Total</b-col>
                <b-col class="celda-head celda-head-total text-center">D. Libres</b-col>
  			    	</b-row>

  			    	<div v-if="dia.horas" class="tabla-body">
  			    		<div v-for="(hora, h_index) in dia.horas" :key="h_index">
  			    			<DashboardDisponibilidadFranja :dia="dia" :hora="hora"></DashboardDisponibilidadFranja>
  			    		</div>
  			    	</div>
        	    </div>
        	  </div>
	    		</b-collapse>
	    	</div>

	    </div>
  </div>
</template>


<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
	import DashboardDisponibilidadFranja from '@/components/Dashboard/DashboardDisponibilidadFranja';

  export default {
    name: 'DashboardDisponibilidad',
    components:{
    	DashboardDisponibilidadFranja
    },
    data(){
      return {
        diasAbiertos: {},
        fechaSeleccionada: null
      }
    },
    mounted () {
    	this.fetchAgendaDisponible()
    },
    watch: {
      agenda_disponible: {
        immediate: true,
        handler(newVal) {
          if (newVal && newVal.length > 0) {
            const fechaExiste = newVal.some(dia => dia.fecha === this.fechaSeleccionada)
            this.fechaSeleccionada = fechaExiste ? this.fechaSeleccionada : newVal[0].fecha
            this.reiniciarColapsoDia()
          } else {
            this.fechaSeleccionada = null
            this.diasAbiertos = {}
          }
        }
      }
    },
    methods:{
      ...mapActions({
      	fetchAgendaDisponible: 'asw/fetchAgendaDisponible',
      	fetchDisponibilidad: 'estado/fetchDisponibilidadNuevo',
      }),
      ...mapMutations({
      }),
      
      toggleDia(index) {
        this.$set(this.diasAbiertos, index, !this.diasAbiertos[index])
      },

      reiniciarColapsoDia() {
        this.diasAbiertos = { 0: true }
      },
      
      actualizar(){
      	if(this.agenda_disponible){
      		for(let i in this.agenda_disponible){
      			let dia = this.agenda_disponible[i]
      			for(let j in dia.horas){
      				let hora = dia.horas[j]
      				this.fetchDisponibilidad({dia:dia.fecha,hora:hora.hora})		
      			}
      		}
      	}
      },
      totalDia(){
        if(!this.disponibilidad){
          return {
            totalInasistencias: 0,
            totalCancelaciones: 0,
            ocupacionTotal: '0/0 (0%)'
          };
        }

        let totalInasistencias = 0;
        let totalCancelaciones = 0;
        let sumatoriaCapacidad = 0;
        let sumatoriaOcupacion = 0;

        for(let key of Object.keys(this.disponibilidad)){
          let estado = this.disponibilidad[key];
          sumatoriaCapacidad += estado.total_capacidad || 0
          sumatoriaOcupacion += estado.total_ocupacion || 0
          totalInasistencias += estado.total_inasistencias || 0;
          totalCancelaciones += estado.total_cancelaciones || 0;
        }

        // Calcular porcentaje de ocupación (cupos ocupados sobre total)
        let porcentaje = sumatoriaCapacidad > 0 ? (sumatoriaOcupacion / sumatoriaCapacidad * 100) : 0
        porcentaje = porcentaje.toFixed(0)

        return {
          totalInasistencias: totalInasistencias,
          totalCancelaciones: totalCancelaciones,
          ocupacionTotal: sumatoriaOcupacion + '/' + sumatoriaCapacidad + ' (' + porcentaje + '%)'
        };
      }

    },
    computed:{
      ...mapState({
      	agenda_disponible: state => state.asw.agenda_disponible,
      	tiposNuevos: state => state.asw.tiposNuevaDisponibilidad, 
        user: state => state.auth.user,
        disponibilidad: state => state.estado.disponibilidad,
      }),
      tipos(){
        // Si es sede presencial
        if(this.user && this.user.data.sede_id != 30){
          const excludedTypesPresencial = ['SUA', 'SUB', 'clase_0', 'lab']
          return this.tiposNuevos.filter(tipo => !excludedTypesPresencial.includes(tipo.id))
        }else{
          return this.tiposNuevos.filter(tipo => tipo.id != 'SU')
        }
      },
      ...mapGetters({   
        permiso: 'auth/permiso',
      }),
      fechasAgendaOptions(){
        if(!this.agenda_disponible || this.agenda_disponible.length === 0){
          return []
        }

        return this.agenda_disponible.map(dia => ({
          value: dia.fecha,
          text: dia.texto || dia.fecha
        }))
      },
      agendaFiltrada(){
        if(!this.agenda_disponible || this.agenda_disponible.length === 0){
          return []
        }

        if(!this.fechaSeleccionada){
          return [this.agenda_disponible[0]]
        }

        const diaSeleccionado = this.agenda_disponible.find(dia => dia.fecha === this.fechaSeleccionada)
        return diaSeleccionado ? [diaSeleccionado] : [this.agenda_disponible[0]]
      }

    }
  }
</script>

<style scoped>
.disponibilidad-container {
  max-width: 1400px;
  margin: 35px auto;
}

.disponibilidad-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e5e7eb;
}

.disponibilidad-titulo {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  display: flex;
  align-items: center;
}

/* Leyenda del Mapa de Calor */
.leyenda-container {
  display: flex;
  gap: 15px;
  justify-content: center;
  padding: 10px 15px;
  background-color: #f9fafb;
  border-radius: 6px;
  margin-bottom: 15px;
  border: 1px solid #e5e7eb;
}

.leyenda-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #4b5563;
  font-weight: 500;
}

.leyenda-color {
  width: 24px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.filtro-fecha-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.filtro-fecha-label {
  margin: 0;
  font-size: 0.9rem;
  color: #374151;
  font-weight: 600;
  min-width: 52px;
}

.filtro-fecha-select {
  max-width: 300px;
}

.agenda-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.dia-section {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.dia-header {
  background: linear-gradient(135deg, #0D4E8C 0%, #084079 50%, #052e5c 100%);
  padding: 10px 15px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.dia-header:hover {
  background: linear-gradient(135deg, #0f5aa3 0%, #0a4d8f 50%, #063969 100%);
}

.dia-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.dia-header-left {
  display: flex;
  align-items: center;
}

.chevron-icon {
  color: white;
}

.dia-titulo {
  margin: 0;
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
}

.dia-resumen {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex-wrap: wrap;
}

.resumen-metrica {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 118px;
  padding: 6px 10px;
  color: white;
  background-color: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  backdrop-filter: blur(8px);
}

.resumen-icon {
  flex: 0 0 auto;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
}

.resumen-contenido {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  align-items: center;
}

.resumen-etiqueta {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.68rem;
  font-weight: 500;
  line-height: 1.1;
  white-space: nowrap;
}

.resumen-metrica strong {
  color: white;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.tabla-disponibilidad {
  padding: 10px;
}

.tabla-scroll {
  width: 100%;
}

.tabla-header {
  background-color: #f3f4f6;
  border-radius: 4px;
  margin: 0 0 6px 0;
  padding: 6px 0;
}

.celda-head {
  font-size: 0.8rem;
  color: #374151;
  padding: 6px 4px !important;
  margin: 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.tipo-nombre-corto {
  display: none;
}

.tabla-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

@media (max-width: 768px) {
  .disponibilidad-container {
    padding: 8px;
  }

  .disponibilidad-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .leyenda-container {
    flex-direction: column;
    gap: 8px;
    padding: 8px 10px;
  }

  .filtro-fecha-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .filtro-fecha-select {
    max-width: 100%;
    width: 100%;
  }

  .disponibilidad-titulo {
    font-size: 1.25rem;
  }

  .dia-header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dia-titulo {
    font-size: 1rem;
  }

  .dia-resumen {
    width: 100%;
    gap: 6px;
  }

  .resumen-metrica {
    flex: 1 1 140px;
    min-width: 0;
    padding: 6px 8px;
  }

  .agenda-wrapper {
    gap: 12px;
  }

  .tabla-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .tabla-disponibilidad {
    min-width: 760px;
  }

  .tabla-header,
  .tabla-body > div {
    width: 900px;
    min-width: 900px;
  }

  .tabla-header > .celda-head,
  .tabla-body > div ::v-deep .celda {
    flex: 1 0 0;
    width: 0;
    max-width: none;
  }

  .tabla-header > .celda-head:first-child,
  .tabla-body > div ::v-deep .hora-label {
    flex: 0 0 8.333333%;
    width: 8.333333%;
    max-width: 8.333333%;
  }

  .tabla-header > .celda-head-total {
    flex: 1.35 0 0;
  }

  .tipo-nombre-completo {
    display: none;
  }

  .tipo-nombre-corto {
    display: inline;
  }
}
	
</style>